import { hasEngineScheduleDeploy } from './engineScheduleProjection'
import { resolveEngineScheduleStudyDay } from '../projection/engine/anchorStudyDay'
import { resolveLegacyDeployStudyDay } from '../projection/legacy/resolveLegacyStudyDay'
import { getScheduleIntendedLastStudyDay } from '../projection/scheduleIntendedSpan'
import { MESSAGES } from './constants'

export const getScheduleExceedsStudyDurationTooltip = studyDurationDays =>
  MESSAGES.SCHEDULE_EXCEEDS_STUDY_DURATION(studyDurationDays)

export const isScheduleTruncatedByStudyDuration = (schedule, studyDurationDays, context = {}) => {
  if (studyDurationDays == null || studyDurationDays < 1 || !schedule) return false

  const anchorContext = {
    useAbsoluteStartDate: context.useAbsoluteStartDate,
    absoluteStartDate: context.absoluteStartDate,
    visits: context.visits || [],
    arms: context.arms || context.armsForEngine || [],
    selectedArmVisitIds: context.selectedArmVisitIds ?? null,
    projectionMode: context.projectionMode || 'template',
    participantVisits: context.participantVisits ?? null,
    resolveInstrumentStudyDay: context.resolveInstrumentStudyDay || (() => null),
  }

  const firstStudyDay = hasEngineScheduleDeploy(schedule)
    ? resolveEngineScheduleStudyDay(schedule, anchorContext)
    : resolveLegacyDeployStudyDay(context.instrumentData || {}, schedule, anchorContext)

  if (firstStudyDay == null) return false

  const intendedLast = getScheduleIntendedLastStudyDay(firstStudyDay, schedule)
  if (intendedLast == null) return false

  return intendedLast > studyDurationDays
}
